module.exports = __webpack_public_path__ + "16_hair_gold.311d0bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/16_hair_gold.png
// module id = mij0
// module chunks = 0